import React from 'react'
import { landingStyles } from '../../styles/landing'
import { Grid, Typography, Box } from "@mui/material"
import {content} from "../../constants"

const ArboristWork = () => {
    const classes = landingStyles()
  return (
    <section id="arboristWork">
    <div className ={classes.container}>
    <Grid container justify="center">
    <Grid item sm={12} xs={12} md={12}> 
    <Typography >
      <Box fontFamily="CormorantBoldItalic" className={classes.heading}>What We Do</Box>
    </Typography>
    </Grid>
      <Grid item sm={12} xs={12} md={6} lg={6} className={classes.imageView}>
        <img src="assets/images/img.jpg" className={classes.Images} alt="" />
      </Grid>
      <Grid item sm={12} xs={12} md={6} lg={6} className={classes.letsPlanDesc}>
        <Typography component="div">
          <Box
            fontFamily="CormorantBoldItalic"
            className={classes.Heading}
          >
            {content.workHeading1}
          </Box>
          <Box
            fontFamily="GothamBook"
            className={`${classes.Message}`}
          >
            {content.workMessage1}           
          </Box>
        </Typography>
      </Grid>
    </Grid>
    <Grid container justify="center">       
      <Grid item sm={12} xs={12} md={6} lg={6} className={classes.Desc1}>
        <Typography component="div">
          <Box
            fontFamily="CormorantBoldItalic"
            className={classes.Heading1}
          >
            {content.workHeading2}          
          </Box>
          <Box
            fontFamily="GothamBook"
            className={`${classes.Message}`}
          >
            <ul style={{listStyle:"none"}}>
              <li>Species identification</li>
              <li>DBH or tree's diameter</li>
              <li>Health rating</li>
              <li>Any diseases or ailments</li>
              <li>Maintenance recommendations</li>
              <li>Risk mitigation</li>
              <li>Risk assessment</li>
              <li>Further actions to be taken</li>             
            </ul>
          </Box>
        </Typography>
      </Grid>
      <Grid item sm={12} xs={12} md={6} lg={6} className={classes.imageView}>
        <img src="assets/images/report1.jpg" className={classes.images} alt="" />
      </Grid>
    </Grid>
    </div>
    </section>
  )
}

export default ArboristWork